import { Alert, Box, Button, Container, FormControl, InputAdornment, InputLabel, LinearProgress, MenuItem, Select, Skeleton, Snackbar, Stack, TextField, Typography } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import CloudDoneOutlinedIcon from '@mui/icons-material/CloudDoneOutlined';
import Apercu from './Apercu';
import { useDispatch } from 'react-redux';
import { modifsuccess,showapercu } from "./AchatsSlice";
export default function EditAchat() {
    const userData = useSelector(state => state.userData);
    const id = userData.id;
    const apitoken = userData.apitoken;
    const apiUrl = process.env.REACT_APP_API_URL;

    const achatsData = useSelector(state => state.achatsData);
    const currentachat = useSelector(state => state.achatsData.currentAchat);
    const ListFournisseur = achatsData.listFournisseurs;

    const dispatch= useDispatch();

    const formatDateToFrench = (dateString) => {
      const [date] = dateString.split('T');
      const [year, month, day] = date.split('-');
      return `${year}-${month}-${day}`;
    };

    const handleFournisseurChange = (event) => {
        setvalFournisseur(event.target.value);
      };
    const [Progession, setProgession] = useState(false);
    const [valFournisseur, setvalFournisseur] = useState(currentachat['0'].fournisseur.id);
    const [etatFacture, setEtatFacture] = useState(currentachat['0'].etat);
    const [Chargement, setChargement] = useState(false);
    const [rechercheInput,setRchercheInput] = useState('');
    const [valMarque, setMarque] = useState('Tout');
    const [valCategorie, setCategorie] = useState('Tout');
    const [listMarque,setListMarque] = useState([]);
    const [listCat,setListCat] = useState([]);
    const [listProduits, setListProduits] = useState([]);

    const navigate = useNavigate();

    const fournisseurField = useRef('')
    const factureField = useRef('')
    const montantField = useRef('')
    const etatField = useRef('')
    const dateArrivageField = useRef('')
    const dateReglementField = useRef('')
    const rechercheField = useRef('')
    let listAchats=useRef([]);
  
    const formatDateToIso = (dateString) => {
      const formattedDate = new Date(`${dateString}T00:00:00Z`);
      formattedDate.setHours(23, 59, 59, 999);
      return formattedDate.toISOString();
      };

      const removeZeroStock = (list) => {
        return list.current.filter(item => item.stock !== "0");
      };
    const ShowApercu =() =>{
        dispatch(showapercu(true))
   }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: theme.palette.common.black,
          color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
          fontSize: 14,
        },
      }));

        const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }));

  const handleEtatChange =(event) =>{
    setEtatFacture(event.target.value);
  }

  const Recherche=(event) =>{
    const recherche=rechercheField.current.value
    if(recherche!==rechercheInput){
      setRchercheInput(recherche)
       }
  }

  const handleMarqueChange = (event) => {
    setMarque(event.target.value);
  };

  const handleCategorieChange = (event) => {
    setCategorie(event.target.value);
  }

    const getMarque=async () => {
        try {
        const response = await axios.post(`${apiUrl}marques/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListMarque(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }
    const getCategorie=async () => {
        try {
        const response = await axios.post(`${apiUrl}categories/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        setListCat(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }

    const getListAchat=async (result) => {
      try {

      const apiUrl = process.env.REACT_APP_API_URL;
      const idachat = currentachat.map(achat => achat._id);
      const response = await axios.post(`${apiUrl}list/achat/${id}/${apitoken}/${idachat}`,
        {
          timeout: 20000,
        }
      );
         response.data.produits.map(product => {
          const _id=product._id
          const designation=product.designation
          const stock=product.stock
          const unite=product.unite
          
          const existingProductIndex = listAchats.current.findIndex(item => item._id === _id);
          if (existingProductIndex === -1) {
          const valeurs = {_id,designation,stock,unite};
          listAchats.current.push({...valeurs});
          }

      });
      setListProduits(result);
      }
   catch (error) {
    navigate('/');    
  }
  setChargement(false);
  }

    const getProduits=async () => {
        setChargement(true);
        try {
        const response = await axios.post(`${apiUrl}produits/${id}/${apitoken}`,
          {
            timeout: 20000,
          }
        );
        getListAchat(response.data);
        }
     catch (error) {
      navigate('/');    
    }
    }

    const StockUpdate = (event) => {
        const qte = event.target.value;

        const id = event.target.id;
        const updatedListProduits = listProduits.map(product => {
            if (product._id === id) {
                product.stock = qte
                const _id=product._id
                const designation=product.designation
                const stock=product.stock
                const unite = product.stock * product.qte_pack
                const valeurs={_id,designation,stock,unite}
                // Vérifier si l'_id existe déjà dans le tableau
                const existingProductIndex = listAchats.current.findIndex(item => item._id === _id);
                if (existingProductIndex !== -1) {
                    // Mettre à jour la valeur du stock et les unités
                    listAchats.current[existingProductIndex].stock = stock;
                    listAchats.current[existingProductIndex].unite = unite;
                  } else {
                    // Ajouter le nouveau produit au tableau
                    listAchats.current.push({...valeurs});
                  }
                return { listAchats };
            }
            return product;
        });
        
    };

    function ShowList() {
        if(listProduits.length > 0){
            let listFiltre=listProduits
            if(rechercheInput.length > 2) {
                listFiltre = listFiltre.filter(produit => produit.designation.toLowerCase().includes(rechercheInput.toLowerCase()))
            }
            if(valMarque!=="Tout") {
                listFiltre = listFiltre.filter(produit => produit.marque["id"] === valMarque)
            }
      
            if(valCategorie!=="Tout") {
              listFiltre = listFiltre.filter(produit => produit.categorie["id"] === valCategorie)
          }
        return listFiltre.map(Produit => {
            const currentQte = listAchats.current.find(item => item._id === Produit._id);
            let stock="0";
            if(currentQte){
                stock=currentQte.stock;
            }

            return(
            
            <StyledTableRow key={Produit._id}>
            <StyledTableCell component="th" scope="row">
              {Produit.designation}
            </StyledTableCell>
            <StyledTableCell component="th" scope="row">
            <TextField
        onChange={StockUpdate}
        defaultValue={stock}
        id={Produit._id}
        label="Packs"
        size='normal'
        type='number'
        variant="outlined"
      />
            </StyledTableCell>
            </StyledTableRow>
            )
            
        });
        
    }
    else{
        return <tr>
            <td colSpan={6} align='center'>Pas de données</td>
        </tr>;
    }
    
    }    

    const Modifier = async () => {

      const idfournisseur=fournisseurField.current.value
      if(idfournisseur==="")
      {
        alert("veillez sélectionner un fournisseur")
        return
      }
      setProgession(true);
      let fournisseur = ListFournisseur.find(item => item._id === idfournisseur);
      fournisseur = fournisseur.designation
      fournisseur={
          "id" : idfournisseur,
          "designation" : fournisseur,
      };

      let facture = factureField.current.value
      if(facture===""){
          facture=0
      }
      let montant = montantField.current.value
      if(montant===""){
          montant=0
      }
      const etat = etatField.current.value
      const dateArrivage = formatDateToIso(dateArrivageField.current.value)
      const dateReglement = formatDateToIso(dateReglementField.current.value)
      const produits = removeZeroStock(listAchats)
      const idachat = currentachat.map(achat => achat._id);
      try {
      const apiUrl = process.env.REACT_APP_API_URL;
      const response = await axios.post(`${apiUrl}edit/achat/${id}/${apitoken}/${idachat}`,
        {
              fournisseur,
              facture,
              montant,
              etat,
              dateArrivage,
              dateReglement,
              produits,
          },
          {
            timeout: 20000,
          }
        );
          dispatch(modifsuccess(true));
          navigate('/home/achats', { replace: true });
      }
   catch (error) {
    navigate('/'); 
  }
  setProgession(false);
  }    
    useEffect(() =>{
        getProduits();
        getMarque();
        getCategorie();
        },[]);

  return (
    <Container maxWidth="lg" sx={{ marginTop: '40px' }}>
    <Typography variant="h4" align='center' color="primary">
        Nouvel Achat
        </Typography>

        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} />
         :
          
          <Box display="flex" width="100%" mt={5}>

              <FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Fournisseur</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id={valFournisseur}
          inputRef={fournisseurField}
          value={valFournisseur}
          label="Fournisseur"
          onChange={handleFournisseurChange}
        >
          {ListFournisseur.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
          </Select>
          </FormControl>

              <TextField sx={{ marginLeft: 2 }}
            inputRef={factureField}
            id="input-with-icon-textfield"
            label="N° Facture"
            size='normal'
            defaultValue={currentachat.map(achat => achat.facture)}
        variant="outlined"
      />              

              <TextField sx={{ marginLeft: 2 }}
            inputRef={montantField}
            id="input-with-icon-textfield"
            label="Montant"
            size='normal'
            type='number'
            defaultValue={currentachat.map(achat => achat.montant)}
        variant="outlined"
      />              

<FormControl sx={{ minWidth: 150,marginLeft: 2 }}>
<InputLabel id="demo-simple-select-label">Etat</InputLabel>
<Select

labelId="demo-simple-select-label"
id="demo-simple-select"
label="Etat"
inputRef={etatField}
onChange={handleEtatChange}
value={etatFacture}
>
<MenuItem value='Réglée' key='Réglée'>Réglée</MenuItem>
<MenuItem value='Non Réglée' key='Non Réglée'>Non Réglée</MenuItem>
</Select>
</FormControl>

              <TextField sx={{ marginLeft: 2 }}
            inputRef={dateArrivageField}
            defaultValue={formatDateToFrench(currentachat['0'].dateArrivage)}
            id="input-with-icon-textfield"
            label="Date d'arrivage"
            size='normal'
            type='date'
        variant="outlined"
      />              

              <TextField sx={{ marginLeft: 2 }}
            inputRef={dateReglementField}
            defaultValue={formatDateToFrench(currentachat['0'].dateReglement)}
            id="input-with-icon-textfield"
            label="Date réglement"
            size='normal'
            type='date'

        variant="outlined"
      />              
</Box> 
}
    <Typography variant="h4" align='center' color="primary" sx={{ marginTop: '40px' }}>
        Produits
        </Typography> 

        <Box display="flex" width="100%" mt={5}>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
         :
        <TextField
        onKeyUp={Recherche}
        inputRef={rechercheField}
        id="input-with-icon-textfield"
        label="Recherche"
        size='normal'
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
        variant="outlined"
      />
      
       }
<Box sx={{ marginLeft: 2 }}>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
         <FormControl sx={{ minWidth: 150 }}>
         <InputLabel id="demo-simple-select-label">Marque</InputLabel>
         <Select
         
         labelId="demo-simple-select-label"
         id="demo-simple-select"
         value={valMarque}
         label="Marque"
         onChange={handleMarqueChange}
       >
        <MenuItem value='Tout'>Tout</MenuItem>
         {listMarque.map((item) => (
         <MenuItem key={item._id} value={item._id}>
           {item.designation}
         </MenuItem>
       ))}
         </Select>
         </FormControl>
}
</Box>
<Box sx={{ marginLeft: 2 }}>
{Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={150} />
         :
<FormControl sx={{ minWidth: 150 }}>
          <InputLabel id="demo-simple-select-label">Catégorie</InputLabel>
          <Select
        
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={valCategorie}
          label="Catégorie"
          onChange={handleCategorieChange}
        >
          <MenuItem value='Tout'>Tout</MenuItem>
          {listCat.map((item) => (
          <MenuItem key={item._id} value={item._id}>
            {item.designation}
          </MenuItem>
        ))}
          </Select>
          </FormControl>
}
</Box>
        </Box>
        {Chargement ? 
        <Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={200} />
         :
         <>
        <TableContainer sx={{ marginTop: '20px' }} component={Paper}>
          
          { Progession ?
    <Box >
  <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
        <LinearProgress color="success" />
      </Stack>
    </Box>
            :
            ''
            }
          
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <StyledTableCell>Désignation</StyledTableCell>
            <StyledTableCell>Quantité</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <ShowList/>
        </TableBody>
      </Table>
    </TableContainer>
    </>
}
<Box display="flex" width="100%" mt={2}>
<Box style={{ marginLeft: 'auto' }}>

{Chargement ? 
<Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
:

<Button sx={{ marginRight: '20px' }} variant="contained" size='large' color="primary" startIcon={<RemoveRedEyeOutlinedIcon/>} onClick={ShowApercu} >
Aperçu
</Button>  
} 
{Chargement ? 
<Skeleton sx={{ marginTop: '20px' }}  variant="rounded" height={56} width={241} />
:

<Button variant="contained" disabled={Progession} size='large' color="success" startIcon={<CloudDoneOutlinedIcon/>} onClick={Modifier} >
Enregistrer
</Button>  
} 
</Box>
</Box>
<Apercu Achats={listAchats} />
    </Container>
  )
}
